function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  /* 섹션의 기본적인 레이아웃 */\n  padding: 1rem;\n  margin: 1rem 0;\n  border: 1px solid var(--theme-border, #e5e7eb);\n  border-radius: 0.5rem;\n  background-color: var(--theme-card-background, white);\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  font-weight: 600;\n  margin-bottom: 1rem;\n  font-size: 1.125rem;\n  color: var(--theme-text, #111827);\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  font-size: 0.875rem;\n  color: var(--theme-text-secondary, #6b7280);\n  margin-bottom: 1rem;\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  /* 아이템들을 어떻게 배치할지 정의 (예: flexbox, grid) */\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
import React from 'react';
import styled from '@emotion/styled';
import { RoadmapItem } from '@edusense/shared-ui-kit';
// Styled components for RoadmapSection
var SectionContainer = styled.div(_templateObject());
var Title = styled.h3(_templateObject1());
var Description = styled.p(_templateObject2());
var ItemsContainer = styled.div(_templateObject3());
var RoadmapSection = function(param) {
    var section = param.section, title = param.title, description = param.description, items = param.items, courses = param.courses, _param_showTitle = param.showTitle, showTitle = _param_showTitle === void 0 ? true : _param_showTitle;
    // section prop이 있으면 우선 사용
    var displayTitle = (section === null || section === void 0 ? void 0 : section.title) || title;
    var displayDescription = (section === null || section === void 0 ? void 0 : section.description) || description;
    // 아이템 렌더링을 위한 데이터 준비
    var displayItems = [];
    if (section === null || section === void 0 ? void 0 : section.courses) {
        // section의 courses를 사용
        displayItems = section.courses.map(function(course) {
            return {
                id: course.id,
                label: course.title
            };
        });
    } else if (courses) {
        // courses prop을 사용
        displayItems = courses.map(function(course) {
            return {
                id: course.id,
                label: course.title
            };
        });
    } else if (items) {
        // items prop을 사용
        displayItems = items;
    }
    return /*#__PURE__*/ React.createElement(SectionContainer, null, showTitle && displayTitle && /*#__PURE__*/ React.createElement(Title, null, displayTitle), displayDescription && /*#__PURE__*/ React.createElement(Description, null, displayDescription), /*#__PURE__*/ React.createElement(ItemsContainer, null, displayItems.map(function(item) {
        return /*#__PURE__*/ React.createElement(RoadmapItem, {
            key: item.id,
            label: item.label
        });
    })));
};
export default RoadmapSection;
